"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.eventsByArgs = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const common_1 = require("./common");
const types_1 = require("../types");
/**
 * @hidden
 *
 * Get a single event by any of its indexed arguments
 */
function eventsByArgs(paddedIds, filters, size, start) {
    const { args, filter } = (0, common_1.createArgsAndFilters)(filters, {
        moduleId: 'ModuleIdEnum',
        eventId: 'EventIdEnum',
    });
    const orderBy = paddedIds
        ? `${types_1.EventsOrderBy.BlockIdAsc}`
        : `${types_1.EventsOrderBy.CreatedAtAsc}, ${types_1.EventsOrderBy.BlockIdAsc}`;
    const query = (0, graphql_tag_1.default) `
    query EventsQuery
      ${args}
     {
      events(
        ${filter}
        orderBy: [${orderBy}]
        first: $size
        offset: $start
      ) {
        nodes {
          eventIdx
          block {
            blockId
            hash
            datetime
          }
        }
      }
    }
  `;
    return {
        query,
        variables: Object.assign(Object.assign({}, filters), (0, common_1.getSizeAndOffset)(size, start)),
    };
}
exports.eventsByArgs = eventsByArgs;
//# sourceMappingURL=events.js.map